// extracted by css-extract-rspack-plugin
export default {"repositoriesListWrapper":"OrgReposListContent-module__repositoriesListWrapper__E8FUE"};